"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const SortableTableHead_1 = __importDefault(require("@/components/DynamicTable/SortableTableHead"));
const style_1 = require("@/components/DynamicTable/DynamicTableRow/style");
const SimpleCell_1 = __importDefault(require("@/components/DynamicTable/Cells/SimpleCell"));
const DeletableCell_1 = __importDefault(require("@/components/DynamicTable/Cells/DeletableCell"));
const TableLoader_1 = __importDefault(require("@/components/TableLoader"));
const constants_1 = require("@/pages/commons/constants");
const constants_2 = require("./constants");
const tableUtils_1 = require("./tableUtils");
const style_2 = require("./style");
const Button_1 = __importDefault(require("@/components/Button"));
function UsersTableView({ usersRows, isLoading, onShowDeleteAlert, onOpenEditUserModalForm, order, orderBy, onRequestSort, onAddUser, }) {
    const renderRoles = (roles) => {
        return roles
            ?.map((role) => {
            return constants_1.ROLES.get(role);
        })
            .join(", ");
    };
    return isLoading && usersRows.length === 0 ? (react_1.default.createElement(TableLoader_1.default, { testId: "users-table-loader", tableLoaderStyle: { height: 300 } })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(style_2.ScrollableTableContainer, { id: "usersTable", shouldOverflowScroll: usersRows.length > 9 },
            react_1.default.createElement(Table_1.default, { stickyHeader: true, sx: style_2.tableStyle },
                react_1.default.createElement(SortableTableHead_1.default, { headCells: constants_2.TABLE_HEAD_CELLS, order: order, testId: "user-table-head", onRequestSort: onRequestSort, orderBy: orderBy }),
                react_1.default.createElement(TableBody_1.default, { "data-testid": "users-table-body" }, (0, tableUtils_1.stableSort)(usersRows, (0, tableUtils_1.getComparator)(order, orderBy)).map((row, i) => {
                    const onOpenModal = () => {
                        onOpenEditUserModalForm(row);
                    };
                    return (react_1.default.createElement(style_1.StyledTableRow, { key: i },
                        react_1.default.createElement(SimpleCell_1.default, { align: "left", variant: "body", key: row?.username, "data-testid": "user-username-cell", onClick: onOpenModal }, row?.username),
                        react_1.default.createElement(SimpleCell_1.default, { variant: "body", "data-testid": "user-department-cell", align: "left" }, constants_1.DEPARTMENTS.get(row?.department)),
                        react_1.default.createElement(SimpleCell_1.default, { align: "left", variant: "body", "data-testid": "user-email-cell", key: row?.email, onClick: onOpenModal }, row?.email),
                        react_1.default.createElement(SimpleCell_1.default, { variant: "body", "data-testid": "user-roles-cell", align: "left", onClick: onOpenModal }, renderRoles(row?.roles)),
                        react_1.default.createElement(DeletableCell_1.default, { align: "left", testId: "delete-user-cell", onDelete: () => {
                                onShowDeleteAlert(row, i);
                            } })));
                })))),
        react_1.default.createElement(style_2.AddUserWrapper, null,
            react_1.default.createElement(Button_1.default, { label: "Add Evaluator", variant: "outlined", color: "secondary", onClick: onAddUser }))));
}
exports.default = UsersTableView;
